export default {
  mode: 'local',
  api: {
    url: `http://${window.location.hostname}:4000`,
  },
};
